import { WdprIconButton, WdprPageHeader } from "components/vista";
import Logo from "components/header/Logo";
import { useContext, useState } from "react";
import StickyCta from "../StickyCta";
import { useIconButtonVariant } from "hooks/txp/useIconButtonVariant";
import { txpMotionClasses, searchOpenLinkId } from "config-txp";
import { Context } from "Context";
import AnalyticsWrapper from "components/shared/AnalyticsWrapper";

export const PageHeaderTxp = ({
	brand,
	chrome,
	currentSelectedOption,
	handleBack,
	handleCloseIcon,
	handleMenuToggle,
	handleSearchBarToggle,
	hideMenuToggler,
	isScrolling,
	menuToggle,
	navigationAppMenuLinksId,
	onLogoLoadCallback,
	searchBarToggle,
	showSearchBar,
	store,
	syndicatedNavigationClass,
}) => {
	const [showStickyCta, setShowStickyCta] = useState(false);

	const variant = useIconButtonVariant({
		toggle: menuToggle,
		isScrolling,
		brand,
	});
	const isCurrentSelectedOption = currentSelectedOption && menuToggle;
	const {
		config: {
			shouldInvertItems,
			chrome: showChromeItems,
			navigation: showNavigation,
		},
	} = useContext(Context);

	return (
		<WdprPageHeader
			background="transparent"
			titleText={isCurrentSelectedOption ? currentSelectedOption : ""}
			className={`${syndicatedNavigationClass}__header__container${
				searchBarToggle
					? ` ${syndicatedNavigationClass}__header__container--search-open`
					: ""
			}${
				isCurrentSelectedOption
					? ` ${syndicatedNavigationClass}__header__container--section-selected`
					: ""
			}`}
			inverse={shouldInvertItems}
		>
			<div
				slot="leading-icon"
				className={`${syndicatedNavigationClass}__header__leading-icon`}
			>
				{isCurrentSelectedOption && (
					<WdprIconButton
						a11yLabel={chrome?.accessibilityTextGoBack || "Go Back"}
						type="button"
						variant={variant}
						size="medium"
						icon-name="back-thick"
						onClick={handleBack}
						className={
							isCurrentSelectedOption
								? txpMotionClasses.motionFadeIn
								: txpMotionClasses.motionFadeOut
						}
					/>
				)}

				{!isCurrentSelectedOption && !hideMenuToggler && (
					<Logo moveLeft onLoadCallback={onLogoLoadCallback} />
				)}
			</div>

			{!isCurrentSelectedOption && hideMenuToggler && (
				<div slot="middle">
					<Logo moveLeft onLoadCallback={onLogoLoadCallback} />
				</div>
			)}

			{showNavigation && (
				<div
					slot="trailing-icon"
					className={`${syndicatedNavigationClass}__header__trailing-icon`}
				>
					{!store && !isCurrentSelectedOption && (
						<StickyCta
							setShowStickyCta={setShowStickyCta}
							showStickyCta={showStickyCta}
							variant={variant}
						/>
					)}

					{/* Search Icon Button */}

					{showChromeItems && showSearchBar && !isCurrentSelectedOption && (
						<AnalyticsWrapper
							analyticsLinkId={
								!searchBarToggle ? `${brand}${searchOpenLinkId}` : ""
							}
							pageTransitionLink={false}
						>
							<WdprIconButton
								className={
									isCurrentSelectedOption
										? txpMotionClasses.motionFadeOut
										: txpMotionClasses.motionFadeIn
								}
								type="button"
								variant={variant}
								iconName="search"
								ariaExpanded={searchBarToggle}
								a11yLabel={chrome?.accessibilityTextShowSearch}
								onClick={handleSearchBarToggle}
								disabled={!showSearchBar}
							/>
						</AnalyticsWrapper>
					)}

					{/* Hamburger */}
					{!menuToggle && !hideMenuToggler && (
						<WdprIconButton
							ariaControls={navigationAppMenuLinksId}
							ariaExpanded={menuToggle}
							a11yLabel={chrome?.accessibilityTextShowNavigation}
							type="button"
							variant={variant}
							size="medium"
							icon-name="menu-global-nav"
							onClick={handleMenuToggle}
						/>
					)}

					{/* Back */}
					{menuToggle && (
						<WdprIconButton
							a11yLabel={chrome?.accessibilityTextCloseNavigation}
							ariaControls={navigationAppMenuLinksId}
							ariaExpanded={menuToggle}
							iconName="close-reversed"
							onClick={handleCloseIcon}
							size="medium"
							type="button"
							variant={variant}
						/>
					)}
				</div>
			)}
		</WdprPageHeader>
	);
};

export default PageHeaderTxp;
